import { useMemo } from 'react'
import { useStoreActions, useStoreState } from '../../../../store/hooks'
import Character from '../../components/Character'

const DailyPuzzleCharacter: React.FC = () => {
    const puzzle = useStoreState((state) => state.dailyPuzzleViewV2.puzzle)
    const progressGameTree = useStoreState((state) => state.dailyPuzzleViewV2.progressGameTree)
    const myColor = useStoreState((state) => state.dailyPuzzleViewV2.myColor)
    const feedbackType = useStoreState((state) => state.dailyPuzzleViewV2.feedbackType)
    const setFeedbackType = useStoreActions((state) => state.dailyPuzzleViewV2.setFeedbackType)

    const positions = useMemo(
        () => progressGameTree.positions.filter((position) => position.position.turn === myColor),
        [progressGameTree.positions, myColor],
    )

    const clearFeedbackType = () => {
        setFeedbackType(undefined)
    }

    return (
        <Character
            avatar="/assets/images/characters/puzzle-character.webp"
            message={puzzle?.description || ''}
            myColor={myColor}
            movesCount={positions.length}
            feedbackType={feedbackType}
            clearFeedbackType={clearFeedbackType}
        />
    )
}

export default DailyPuzzleCharacter
